<mat-progress-bar *ngIf="loading" color="accent" mode="indeterminate"></mat-progress-bar>
<navbar *ngIf="isLoggedIn" (logoutEvent)="logout()">
</navbar>
<div
  class="app-shell"
  [class.app-shell--split-active]="(splitPreviewState$ | async)?.visible"
>
  <div
    class="main-container"
    [class.main-container--shrink]="(splitPreviewState$ | async)?.visible"
  >
    <router-outlet *ngIf="isLoggedIn"></router-outlet>
    <login *ngIf="!isLoggedIn"></login>
  </div>
  <split-preview-overlay *ngIf="isLoggedIn"></split-preview-overlay>
  <button *ngIf="isLoggedIn && !user?.isTicketOnly()" mat-fab color="primary" class="ticket-fab"
    (click)="apriTicket()" matTooltip="Segnala un problema"
    matTooltipPosition="left">
    <mat-icon>bug_report</mat-icon>
  </button>
</div>
